<template>
  <div class="app-main">
    <div class="content-tool">
      <div class="content-tool--nav">
        <div class="content-tool--title fl">姓名</div>
        <el-input placeholder="请输入姓名" icon="search" v-model.trim="uname" @keyup.enter.native="fetchExcelDetail" class="content-tool--input fl"></el-input>
      </div>
      <div class="content-tool--nav">
        <div class="content-tool--title fl">供应商</div>
        <el-input placeholder="请输入供应商" icon="search" v-model.trim="uprovider" @keyup.enter.native="fetchExcelDetail" class="content-tool--input fl"></el-input>
      </div>
      <div class="content-tool--nav">
        <div class="content-tool--title fl" style="width: 80px;">手机号</div>
        <el-input placeholder="请输入手机号" icon="search" v-model.trim="uphone" @keyup.enter.native="fetchExcelDetail" class="content-tool--input fl" style="width: calc(100% - 90px);"></el-input>
      </div>
      <div class="content-tool--nav" style="width: 30%;">
        <div class="content-tool--title fl" style="width: 80px;">转账状态</div>
        <el-select v-model="payStatus" placeholder="请选择">
          <el-option v-for="item in payStatusValues" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="content-tool--operate">
        <el-button type="primary" class="content-tool--qry el-button-reset" @click="fetchExcelDetail">查询</el-button>
        <el-button class="content-tool--reset el-button-reset" @click="reset">重置</el-button>
        <el-button @click="downloadExcel" type="primary" style="margin-left: 20px;">下载excel文件</el-button>
      </div>
    </div>
    <div class="content-search-title" style="overflow: hidden; border-bottom: 1px solid #ebeef5; margin: 0 30px 20px 30px;">
      <div class="content-table--title fl" style="line-height: 55px;">
        <span style="font-size: 18px; font-weight: bold;">详情记录</span>&nbsp;总共转账
        <span class="record-num">{{ params.totalNum }}</span>
         笔，成功
        <span class="record-num">{{ params.sucNum }}</span>&nbsp;笔，失败 <span class="record-num">{{ params.failNum }}</span>&nbsp;笔
      </div>
    </div>
    <div class="content-table">
      <el-table :data="paydetails" size='medium' row-click="fetchRowDetail" tooltip-effect="dark">
        <el-table-column prop="id" label="序号" width="80px"></el-table-column>
        <el-table-column prop="uname" label="姓名"></el-table-column>
        <el-table-column prop="uprovider" label="供应商" show-overflow-tooltip></el-table-column>
        <el-table-column prop="payStatus" label="状态" width="100px" :formatter="formatterStatusData"></el-table-column>
        <el-table-column prop="umoney" label="税前金额" align="center" width="100px"></el-table-column>
        <el-table-column prop="finalPayAmount" label="实发金额" align="center" width="100px" v-if="isPersonalTax == 1"></el-table-column>
        <el-table-column prop="personalTax" label="所得税" align="center" width="100px" v-if="isPersonalTax == 1"></el-table-column>
        <el-table-column prop="personalInfo" label="所得税详情" align="center" width="150px" v-if="isPersonalTax == 1"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="ucardid" label="身份证号" width="200px"></el-table-column>
        <el-table-column prop="uphone" label="手机号"></el-table-column>
        <el-table-column prop="ubank" label="开户银行" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ubankcard" label="银行卡号" width="200px"></el-table-column>
        <el-table-column prop="umonth" label="发放月份"></el-table-column>
        <el-table-column prop="remark" label="转账备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="errMsg" label="失败原因" width="150px" :formatter="formatterReasonData" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'exceldetail',
  data() {
    return {
      paydetails: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      uname: '',
      uprovider: '',
      uphone: '',
      params: {
        opId: '',
        totalNum: 0,
        sucNum: 0,
        failNum: 0,
      },
      payStatus: 4,
      payStatusValues: [{
        value: 4,
        label: '全部',
      }, {
        value: 0,
        label: '正在处理',
      }, {
        value: 1,
        label: '成功',
      }, {
        value: 2,
        label: '失败',
      }],
      isPersonalTax: false,
    };
  },
  mounted() {
    this.params.opId = this.$route.query.opId;
    this.params.totalNum = this.$route.query.totalNum;
    this.params.sucNum = this.$route.query.sucNum;
    this.params.failNum = this.$route.query.failNum;
    this.fetchExcelDetail();
  },
  methods: {
    formatterStatusData(data) {
      if (data.payStatus === 0) {
        return '正在处理';
      } else if (data.payStatus === 1) {
        return '成功';
      } else if (data.payStatus === 3) {
        return '取消转账';
      }
      return '失败';
    },
    formatterReasonData(data) {
      if (data.payStatus === 0) {
        return '-';
      } else if (data.payStatus === 1) {
        return '-';
      }
      return data.errMsg;
    },
    fetchExcelDetail() {
      api.fetchExcelDetail({
        params: {
          params: {
            uname: this.uname,
            uprovider: this.uprovider,
            uphone: this.uphone,
            payStatus: this.payStatus,
            index: this.currentPage - 1,
            size: this.pageSize,
            opId: this.params.opId,
          },
        },
      }).then((res) => {
        this.paydetails = res.data;
        this.total = res.count;
        this.isPersonalTax = res.isPersonalTax;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchExcelDetail();
    },
    reset() {
      this.uname = '';
      this.uprovider = '';
      this.uphone = '';
      this.payStatus = 3;
    },
    downloadExcel() {
      // eslint-disable-next-line
      window.location = `/paywages/api/excel/export?opId=` + this.params.opId + `&uname=` + this.uname
                    + '&uprovider=' + this.uprovider + '&uphone=' + this.uphone
                    + '&payStatus=' + (this.payStatus === 3 ? '' : this.payStatus);
    },
  },
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 100%;
  }
}

.content-tool {
  padding: 27px 17px 20px 17px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 20px 20px 0px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 20%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
  padding: 30px 17px 10px 17px;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 0px 20px 0px 20px;
}
.content-search-title {
  padding: 20px 0 0 0;
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 15px;
    letter-spacing: 2px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    .record-num {
      color: #20a0ff;
    }
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
  .color-bule {
    color: #0779bd;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  margin: 30px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}
</style>




// WEBPACK FOOTER //
// src/components/exceldetail.vue